import React from "react";

function AnnexesCGU() {
  return (
    <section>
      <h2>1. Objet</h2>
      <p>
        La coopérative Le Média (ci-après « <strong>Le Média</strong> ») édite
        une plateforme accessible à l’adresse{" "}
        <a
          href="https://lemediatv.fr"
          target="_blank"
          rel="noopener noreferrer"
        >
          lemediatv.fr
        </a>{" "}
        proposant à toute personne qui le souhaite (ci-après l’«{" "}
        <strong>Utilisateur</strong> »)  d’accéder à des contenus éditoriaux
        sous forme d’articles de presse écrite ou d’œuvres audiovisuelles
        (ci-après le « <strong>Site</strong> »). Le Média propose également,
        sous réserve de la souscription à un abonnement, des services
        complémentaires, tel qu’explicité ci-après.
      </p>
      <p>
        Le Média et l’Utilisateur sont ci-après désignés ensemble ou
        individuellement une ou les « <strong>Partie(s)</strong> ».
      </p>
      <p>
        Les présentes conditions générales d’utilisation (ci-après les « 
        <strong>Conditions Générales</strong> ») ont pour objet de fixer les
        modalités et conditions d’utilisation des services proposés sur le Site
        (ci-après les « <strong>Services</strong> »), ainsi que de définir les
        droits et obligations des Parties dans ce cadre.
      </p>
      <p>
        Elles sont accessibles et imprimables à tout moment par un lien direct
        en bas de page du Site.
      </p>
      <p>
        Elles peuvent être complétées, le cas échéant, par des conditions
        d’utilisation particulières à certains Services, lesquelles complètent
        les présentes conditions générales et, en cas de contradiction,
        prévalent sur ces dernières.
      </p>
      <h2>2. Exploitant du Site et des Services</h2>
      <p>
        Le Site et les Services sont exploités par la{" "}
        <strong>
          SCIC Le Média (Société Coopérative d’Intérêt Collectif Le Média)
        </strong>
        , RCS 880 234 471, dont le siège social est situé au 242 Bd Voltaire,
        75011 PARIS.
      </p>
      <p>Le Média peut être contactée aux coordonnées suivantes&nbsp;:</p>
      <p>
        Adresse postale&nbsp;: 94 rue des sorins, 93100 Montreuil
        <br />
        Téléphone&nbsp;: 07 57 18 86 39
        <br />
        Adresse électronique&nbsp;:{" "}
        <a
          href="mailto:contact@lemediatv.fr"
          target="_blank"
          rel="noopener noreferrer"
        >
          contact@lemediatv.fr
        </a>
      </p>
      <h2>3. Acceptation des Conditions Générales</h2>
      <p>
        L’acceptation des Conditions Générales par les Utilisateurs qui
        souscrivent à un abonnement sur le Site (ci-après les « 
        <strong>Abonnés</strong> ») et/ou achètent des parts sociales au sein du
        Média via le Site (ci-après les « <strong>Socio</strong> ») est
        matérialisée par une case à cocher dans le formulaire d’inscription.
        Ainsi, en s’abonnant aux Services du Média ou en devenant Socio dans les
        conditions des articles «&nbsp;Souscription d’un abonnement auprès du
        Média » ou « Devenir Socio&nbsp;» ci-après, l’Abonné ou le Socio déclare
        avoir pris connaissance des Conditions Générales et les accepter
        expressément.
      </p>
      <p>
        S’agissant des Utilisateurs non-abonnés aux Services du Média, leur
        utilisation du Site et/ou des Services entraîne leur acceptation des
        Conditions Générales, sans restriction ni réserve.
      </p>
      <p>
        L’acceptation des Conditions Générales ne peut être que pleine et
        entière. Toute adhésion sous réserve est considérée comme nulle et non
        avenue.{" "}
      </p>
      <p>
        L’Utilisateur qui n’accepte pas d’être lié par les Conditions Générales
        ne doit pas accéder au Site, ni utiliser les Services.
      </p>
      <h2>4. Accès aux Services</h2>
      <p>Le Site et les Services sont accessibles :</p>
      <ul>
        <li>
          A toute personne physique disposant de la pleine capacité juridique
          pour s’engager au titre des présentes Conditions Générales.
          L’Utilisateur qui ne dispose pas de la pleine capacité juridique doit
          obtenir l’accord de son représentant légal avant d’accéder au Site et
          aux Services, ce qu’il reconnait et accepte.
        </li>
        <li>
          A toute personne morale agissant par l’intermédiaire d’une personne
          physique disposant des pouvoirs pour contracter au nom et pour le
          compte de la personne morale.
        </li>
      </ul>
      <p>
        Le périmètre des Services accessibles par l’Utilisateur dépend de son
        statut.
      </p>
      <p>Il peut être :</p>
      <ul>
        <li>
          Simple « Utilisateur » par navigation sur le Site. Il a ainsi accès à
          l’ensemble des Services et contenus présentés sur le Site ;
        </li>
        <li>
          « Abonné » en suivant la procédure d’abonnement explicitée ci-après.
          Ce statut donne accès à davantage de contenus et Services que ceux
          accessibles par le simple Utilisateur ;
        </li>
        <li>
          « Socio ». Ces termes désignent les Abonnés qui souhaitent acquérir
          des parts sociales au sein du Média. les Socios ont accès à des
          Services, contenus et avantages supplémentaires de ceux ouverts aux
          Abonnés et – par voie de conséquence – aux Utilisateurs.
        </li>
      </ul>
      <p>les Socios deviennent ainsi sociétaires du Média.</p>
      <h2>Souscription d’un abonnement auprès du Média</h2>
      <h3>5.1 Moment de la souscription</h3>
      <p>
        L’Utilisateur reconnait et accepte que pour bénéficier des Services et
        contenus réservés aux Abonnés, il est tenu de souscrire un abonnement
        depuis le Site, selon la procédure décrite ci-dessous, (ci-après l’«{" "}
        <strong>Abonnement</strong>&nbsp;»).
      </p>
      <p>
        Les Utilisateurs disposent de la faculté de s’abonner aux Services du
        Média lors de leur première visite sur le Site ou à tout moment.
      </p>
      <h3>5.2 Procédure d’Abonnement</h3>
      <h4>
        5.2.1 Aux fins de souscription d’un Abonnement, l’Utilisateur est tenu
        de :
      </h4>
      <ul>
        <li>Se rendre sur la page d’accueil du Site ;</li>
        <li>Cliquer sur l’onglet « S’abonner» ;</li>
        <li>Procéder aux trois étapes suivantes :</li>
      </ul>
      <p>
        <strong>Etape 1 :</strong> S’enregistrer
      </p>
      <p>
        Lors de cette étape, l’Utilisateur qui souhaite s’abonner est tenu de
        s’inscrire en se créant un compte ou de se connecter à son compte s’il
        en a déjà un.
      </p>
      <p>
        Pour se créer un compte, l’Utilisateur doit renseigner les informations
        qui lui sont demandées et notamment son adresse email de contact, le nom
        qu’il souhaite voir apparaitre publiquement.
      </p>
      <p>Il doit en outre définir un mot de passe.</p>
      <p>Ce compte permettra notamment de suivre l’état de son abonnement.</p>
      <p>
        <strong>Etape 2 :</strong> Coordonnées
      </p>
      <p>
        Lors de cette étape, l’Utilisateur qui souhaite s’abonner est tenu de
        renseigner certaines informations personnelles, à savoir ses nom, prénom
        et adresse postale.
      </p>
      <p>
        <strong>Etape 3 :</strong> Participation financière
      </p>
      <p>L’Abonnement est payant.</p>
      <p>L’Utilisateur est ainsi tenu de :</p>
      <ul>
        <li>
          Déterminer le montant de son abonnement parmi les montants proposés
          sur le Site (entre 5 et 50 euros) ; L’Abonné est informé qu’il pourra
          modifier le montant de sa contribution à la hausse ou à la baisse
          (dans les limites susvisées), directement depuis son Compte, au plus
          tard trente (30) jours avant la date d’anniversaire de son Abonnement.
        </li>
        <li>
          Choisir l’échéance de prélèvement (mensuelle ou annuelle) de son
          Abonnement annuel.
          <ul>
            <li>
              En cas de choix pour une périodicité mensuelle, le prix choisi de
              l’abonnement sera divisé par 12 et cette quote part sera prélevée
              chaque mois.
            </li>
            <li>
              En cas de choix pour une périodicité annuelle, le prix de
              l’abonnement sera payé en une seule fois, à la date d’anniversaire
              de la souscription. Indiquer le moyen de paiement retenu (carte
              bancaire ou prélèvement SEPA) et les informations bancaires
              demandées ;
            </li>
          </ul>
        </li>
        <li>
          Cocher les cases « 
          <em>
            J’ai lu et j’accepte les Conditions Générales d’Utilisation Le Média
          </em>
           » et « 
          <em>
            J’ai lu et j’accepte les conditions générales d’utilisation des
            prestataires de paiement Chargebee et Stripe
          </em>{" "}
          &nbsp;» ;
        </li>
        <li>
          Cliquer sur le bouton «  <em>Je valide mon Abonnement</em> ».
        </li>
      </ul>
      <p>
        L’Utilisateur est informé qu’il pourra modifier le montant de sa
        contribution mensuelle à la hausse ou à la baisse à tout moment au cours
        de son Abonnement depuis son Compte tel que ci-après défini.
      </p>
      <h2>6. Devenir Socio</h2>
      <p>
        Aux fins de bénéficier des Services réservés aux Socios notamment
        communautaires (vote aux assemblées générales de la coopérative, accès à
        des tournages notamment), l’Utilisateur doit souscrire des parts
        sociales au sein du Média en suivant la procédure suivante ci-dessous.
        Les Utilisateurs disposent de la faculté de souscrire des parts sociales
        au sein du Média lors de leur première visite sur le Site ou à tout
        moment.
      </p>
      <p>L’Utilisateur est tenu de :</p>
      <ul>
        <li>Se rendre sur la page d’accueil du Site ;</li>
        <li>Cliquer sur l’onglet « Devenir socio » ;</li>
        <li>Procéder aux trois étapes suivantes :</li>
      </ul>
      <p>
        <strong>Etape 1 : </strong>S’enregistrer
      </p>
      <p>
        Si la personne qui souhaite devenir Socio est déjà Abonné, elle doit se
        connecter à son compte à l’aide de ses identifiant et mot de passe.
      </p>
      <p>
        Si la personne qui souhaite devenir Socio est simple Utilisateur, elle
        doit se créer un compte dans les conditions de l’article 5.2.1 Etape 1.
      </p>
      <p>
        Il est à ce titre précisé qu’en faisant le choix de devenir Socio,
        l’Utilisateur deviendra ainsi également Abonné.
      </p>
      <p>
        Les Utilisateurs disposent de la faculté de souscrire des parts sociales
        au sein du Média lors de leur première visite sur le Site ou à tout
        moment.
      </p>
      <p>
        <strong>Etape 2 :</strong> Coordonnées
      </p>
      <p>
        Lors de cette étape, l’Utilisateur est tenu de renseigner certaines
        informations personnelles, à savoir ses nom, prénom et adresse postale.
      </p>
      <p>
        Ces informations permettront d’éditer les parts sociales dont le Socio
        disposera en sa qualité de sociétaire de la coopérative.
      </p>
      <p>
        <strong>Etape 3 :</strong> Participation financière
      </p>
      <p>
        La souscription de parts sociales est payante, dans les conditions
        ci-après définies.
      </p>
      <p>
        L’Utilisateur est ainsi tenu, depuis le Site, de déterminer le nombre de
        parts sociales qu’il souhaite détenir. L’Utilisateur est à ce titre
        informé qu’il est tenu d’acquérir un minimum de 5 parts sociales ; le
        prix unitaire d’une part sociale est indiquée sur le Site ;
      </p>
      <p>
        Si l’Utilisateur qui souhaite devenir Socio n’est pas déjà abonné au
        Média, il devra en outre déterminer le montant de son abonnement dans
        les conditions de l’article 5.2.1 Etape 3 ci-avant.
      </p>
      <p>
        L’Utilisateur est informé qu’il pourra modifier le montant de sa
        participation financière en le modifiant à la hausse ou à la baisse à
        tout moment pendant son Abonnement depuis son compte tel que ci-après
        défini.
      </p>
      <p>Enfin, l’Utilisateur devra déterminer :</p>
      <ul>
        <li>
          le choix de son mode de paiement parmi ceux proposés sur le Site ;
        </li>
        <li>
          cocher les cases :
          <ul>
            <li>
              «{" "}
              <em>
                J’ai lu et j’accepte les conditions générales d’utilisation du
                Média
              </em>
              &nbsp;» ;{" "}
            </li>
            <li>
              « 
              <em>
                J’ai lu et j’accepte les statuts et le règlement intérieur du
                Média
              </em>
              &nbsp;» ;
            </li>
            <li>
              « 
              <em>
                J’ai lu et j’accepte les conditions générales d’utilisation des
                prestataires de paiement Chargebee et Stripe
              </em>{" "}
              &nbsp;».
            </li>
          </ul>
        </li>
        <li>
          cliquer sur le bouton «  <em>Je deviens Socio</em> ».
        </li>
      </ul>
      <h2>7. Dispositions générales applicables aux Abonnements</h2>
      <p>
        Toute demande de création de compte incomplète ne sera pas validée, ce
        que les Utilisateurs reconnaissent et acceptent expressément.
      </p>
      <p>
        Le Média se réserve le droit, à sa libre discrétion et à tout moment
        après la demande de création de compte, de mettre en œuvre tout
        processus de vérification qu’elle jugera utile, notamment s’agissant de
        l’identité et/ou des coordonnées de l’Utilisateur.
      </p>
      <p>
        L’Abonné reconnaît et accepte que l’Abonnement entraîne une inscription
        automatique aux emails relatifs aux transactions depuis le Site (message
        reçu, paiement accepté, …).
      </p>
      <p>
        L’Abonnement entraîne automatiquement l’ouverture d’un compte au nom de
        l’Abonné (ci-après le « <strong>Compte</strong> »), lui donnant accès à
        un espace personnel (ci-après&nbsp;: l’«&nbsp;
        <strong>Espace Personnel</strong>&nbsp;») qui lui permet de gérer son
        utilisation des Services sous une forme et selon les moyens techniques
        que Le Média juge les plus appropriés pour rendre les Services.
      </p>
      <p>
        Les Abonnés peuvent accéder à tout moment à leur Espace Personnel après
        s’être identifiés à l’aide de leur identifiant de connexion et de leur
        mot de passe.
      </p>
      <p>
        Les Abonnés garantissent que toutes les informations qu’ils renseignent
        dans le formulaire de demande d’Abonnement sont exactes, à jour et
        sincères, et ne sont entachées d’aucun caractère trompeur.
      </p>
      <p>
        Ils s’engagent à mettre à jour sans délai ces informations dans leur
        Espace Personnel en cas de modifications, afin qu’elles correspondent
        toujours aux critères susvisés.
      </p>
      <p>
        Les Abonnés sont informés et acceptent que les informations saisies aux
        fins de création ou de mise à jour de leur Compte valent preuve de leur
        identité. Les informations saisies par les Abonnés les engagent dès leur
        validation.
      </p>
      <p>Un seul Compte pourra être créé par Abonné.</p>
      <p>
        Est considérée comme Abonné la personne dont les renseignements
        personnels correspondent à ceux qui ont été fournis sur le formulaire de
        demande d’Abonnement, à l’exclusion de tout tiers, étant entendu que
        dans le cas où le Compte est ouvert par une personne morale, il sera
        valablement opéré par toute personne dûment habilitée.
      </p>
      <p>
        L’Abonné s’engage par conséquent à utiliser les Services personnellement
        et à ne permettre à aucun tiers de les utiliser à sa place ou pour son
        propre compte, sauf à en supporter l’entière responsabilité.
      </p>
      <p>
        L’Abonné est par ailleurs responsable du maintien de la confidentialité
        de ses identifiant et mot de passe et reconnaît expressément que toute
        utilisation des Services depuis son Compte sera réputée avoir été
        effectuée par lui-même.
      </p>
      <p>
        Dans l’hypothèse où l’Abonné constaterait que son Compte a été utilisé à
        son insu ou par une personne non habilitée, il s’engage à en avertir Le
        Média dans les plus brefs délais, aux coordonnées mentionnées à
        l’article « Exploitant du Site et des Services ». Il reconnait au Média
        le droit de prendre toutes mesures appropriées en pareil cas.
      </p>
      <h2>8. Usage non commercial</h2>
      <p>
        L’Utilisateur s’interdit de monnayer, vendre, concéder, échanger et plus
        généralement, négocier tout ou partie de l’accès aux Services ou au
        Site, ainsi qu’aux informations et/ou textes, images, et autres contenus
        exploités par Le Média sur le Site dans le cadre de l’utilisation des
        Services.
      </p>
      <h2>9. Description des Services </h2>
      <p>
        Le Site permet aux Utilisateurs de bénéficier des Services détaillés
        ci-dessous. L’Utilisateur est informé et accepte que certains Services
        soient réservés aux Abonnés et/ou aux Socio, tels qu’explicités
        ci-après.
      </p>
      <h3>
        9.1 Les Services suivants sont proposés à l’ensemble des Utilisateurs
      </h3>
      <h4>9.1.1 Accès libre à des contenus éditoriaux </h4>
      <p>
        En accédant au Site, l’Utilisateur a accès à différents types de
        contenus éditoriaux d’actualité ou sur des thèmes choisis par Le Média,
        sous forme d’articles de presse écrites, de vidéos d’information, de
        témoignages, d’enquêtes, etc.{" "}
      </p>
      <h4>9.1.2 Possibilité de faire des dons défiscalisés</h4>
      <p>
        A travers la plateforme, Le Média offre aux Utilisateurs qui le
        souhaitent la faculté de faire des dons au Média via l’association
        “J’aime l’info”.
      </p>
      <p>
        Selon ce Service, l’Utilisateur peut faire un don d’un montant prédéfini
        de 10, 25, 50 ou 100 euros ou d’un montant libre. Il a en outre la
        faculté de faire un don isolé ou selon une périodicité mensuelle.
      </p>
      <p>
        Pour ce faire, il doit cliquer sur le bouton « Faire un don » ou
        « Soutenir » sur la page d’accueil du Site et suivre les indications
        présentes sur le Site.
      </p>
      <h4>9.1.4 Envoi de newsletters</h4>
      <p>
        Le Média se réserve la possibilité d’adresser des newsletters à tout
        Utilisateur en ayant exprimé le souhait en communiquant à Le Média son
        adresse email.
      </p>
      <p>
        Ces newsletters ont pour objet d’informer les Utilisateurs sur les
        productions, les offres promotionnelles et/ou les appels à soutien de Le
        Média.
      </p>
      <h4>9.1.4 Participation à des tirages au sort</h4>
      <p>
        Le Média se réserve la possibilité d’organiser des tirages au sort aux
        échéances qu’elle déterminera et dont les Utilisateurs sont invités à
        participer.
      </p>
      <h3>
        9.2 Les Services suivants sont proposés aux Abonnés, à l’exclusion de
        tout autre Utilisateur
      </h3>
      <h4>9.2.1 Accès à des contenus éditoriaux spécifiques</h4>
      <p>
        Le Média offre aux Abonnés la possibilité d’avoir accès à des contenus
        éditoriaux spécifiques, tels que notamment, sans que cette liste soit
        exhaustive, des «&nbsp;bonus&nbsp;», des «&nbsp;boites noires&nbsp;» des
        sujets traités par Le Média, des FAQ avec les invités du Média.
      </p>
      <h4>9.2.2 Accès à des newsletters personnalisées</h4>
      <p>
        En complément des newsletters classiques, Le Média adresse aux Abonnés
        et aux Socios des newsletters spécifiques à échéance hebdomadaire.
      </p>
      <h3>9.3 Les Services proposés aux Socio</h3>
      <p>
        En complément des Services réservés aux Abonnés, Le Média met à la
        disposition des Socios un espace d’échanges (ci-après le « 
        <strong>Forum</strong> ») dans le cadre duquel ils peuvent librement
        échanger entre eux sur le sujet de leur choix, mais aussi avec Le Média.
      </p>
      <p>
        les Socios ont accès à d’autres Services privilégiés (et notamment, la
        possibilité de participer à des tournages, de bénéficier de places
        gratuites à des évènements), dont la liste détaillée leur est
        communiquée au moment de leur souscription.
      </p>
      <h2>10. Prix des Services</h2>
      <p>
        Les Services accessibles à l’ensemble des Utilisateurs sont fournis à
        titre gratuit.
      </p>
      <p>
        Les Services proposés aux Abonnés et aux Socios sont fonction d’une
        participation financière tel que détaillé aux articles « Souscription
        d’un Abonnement auprès du Média » ou « Devenir Socio » ci-avant.{" "}
      </p>
      <p>
        Les paiements effectués par carte bancaire ou prélèvement SEPA sont mis
        en œuvre par Chargebee ou Stripe, qui seules conservent les coordonnées
        bancaires de l’Abonné ou du Socio à cette fin.
      </p>
      <p>Le Média ne conserve aucune coordonnée bancaire.</p>
      <p>
        Le prix des Services est dû tant que l’Utilisateur n’a pas exprimé sa
        volonté de se désabonner ou de mettre fin à son statut de Socio,
        mensuellement ou annuellement en fonction du choix exprimé par
        l’Utilisateur.
      </p>
      <p>
        L’Abonné ou le Socio garantit au Média qu'il dispose des autorisations
        nécessaires pour utiliser le mode de paiement choisi. Il s’engage à
        prendre les mesures nécessaires afin que le paiement du prix de
        l’Abonnement ou de sa souscription puisse être effectué.
      </p>
      <h2>11. Données du Média</h2>
      <p>L’Utilisateur reconnaît et accepte expressément :</p>
      <ol>
        <li>
          que les données recueillies sur le Site et les équipements
          informatiques du Média font foi de la réalité des opérations
          intervenues dans le cadre des présentes,
        </li>
        <li>
          que ces données constituent le seul mode de preuve admis entre les
          Parties.
        </li>
      </ol>
      <h2>12. Obligations de l’Utilisateur</h2>
      <p>
        Sans préjudice des autres obligations prévues aux présentes,
        l’Utilisateur s’engage à respecter les obligations qui suivent.
      </p>
      <p>
        <strong>
          12.1 L’Utilisateur s’engage, dans son usage des Services, à respecter
          les lois et règlements en vigueur et à ne pas porter atteinte aux
          droits de tiers ou à l’ordre public.
        </strong>
      </p>
      <p>
        Il est seul responsable du bon accomplissement de toutes les formalités
        notamment administratives, fiscales et/ ou sociales et de tous les
        paiements de cotisations, taxes ou impôts de toutes natures qui lui
        incombent le cas échéant en relation avec son utilisation des Services.
        La responsabilité du Média ne pourra en aucun cas être engagée à ce
        titre.
      </p>
      <p>
        <strong>
          12.2 L’Utilisateur reconnaît avoir pris connaissance sur le Site des
          caractéristiques et contraintes, notamment techniques, de l’ensemble
          des Services.
        </strong>
      </p>
      <p>
        Il est seul responsable de son utilisation des Services et notamment des
        relations qu’il pourra nouer avec les autres Utilisateurs et des
        informations qu’il leur communique dans le cadre des Services. Il lui
        appartient d’exercer la prudence et le discernement appropriés dans ces
        relations et communications. L’Utilisateur s’engage en outre, dans ses
        échanges avec les autres Utilisateurs, à respecter les règles usuelles
        de politesse et de courtoisie.
      </p>
      <p>
        <strong>
          12.3 L’Utilisateur s’engage à faire un usage strictement personnel des
          Services. Il s’interdit en conséquence de céder, concéder ou
          transférer tout ou partie de ses droits ou obligations au titre des
          présentes à un tiers, de quelque manière que ce soit.
        </strong>
      </p>
      <p>
        <strong>
          12.4 L’Utilisateur s’engage à fournir au Média toutes les informations
          nécessaires à la bonne exécution des Services. Plus généralement
          l’Utilisateur s’engage à coopérer activement avec Le Média en vue de
          la bonne exécution des présentes.
        </strong>
      </p>
      <p>
        <strong>
          12.5 L’Utilisateur est seul responsable des contenus de toute nature
          (notamment rédactionnels) qu’il diffuse dans le cadre des Services
          (ci-après désignés : les « Contenus »).
        </strong>
      </p>
      <p>
        Il garantit au Média qu’il dispose de tous les droits et autorisations
        nécessaires à la diffusion de ces Contenus.
      </p>
      <p>
        Il s’engage à ce que les Contenus soient licites, ne portent pas
        atteinte à l’ordre public, aux bonnes mœurs ou aux droits de tiers,
        n’enfreignent aucune disposition législative ou règlementaire et plus
        généralement, ne soient aucunement susceptibles de mettre en jeu la
        responsabilité civile ou pénale du Média.
      </p>
      <p>
        L’Utilisateur s’interdit ainsi de diffuser, notamment et sans que cette
        liste soit exhaustive :
      </p>
      <ul>
        <li>
          des Contenus pornographiques, obscènes, indécents, choquants ou
          inadaptés à un public familial, diffamatoires, injurieux, violents,
          racistes, xénophobes ou révisionnistes,
        </li>
        <li>des Contenus contrefaisants,</li>
        <li>des Contenus attentatoires à l’image d’un tiers,</li>
        <li>
          des Contenus mensongers, trompeurs ou proposant ou promouvant des
          activités illicites, frauduleuses ou trompeuses,
        </li>
        <li>
          des Contenus nuisibles aux systèmes informatiques de tiers (tels que
          virus, vers, chevaux de Troie, etc.),
        </li>
        <li>
          et plus généralement des Contenus susceptibles de porter atteinte aux
          droits de tiers ou d’être préjudiciables à des tiers, de quelque
          manière et sous quelque forme que ce soit.
        </li>
      </ul>
      <p>
        <strong>
          12.6 L’Utilisateur doit prendre les mesures nécessaires pour
          sauvegarder par ses propres moyens les informations de son Espace
          Personnel qu’il juge nécessaires, dont aucune copie ne lui sera
          fournie.
        </strong>
      </p>
      <p>
        <strong>
          12.7 L’Utilisateur est informé et accepte que la mise en œuvre des
          Services nécessite qu’il soit connecté à internet et que la qualité
          des Services dépend directement de cette connexion, dont il est seul
          responsable.
        </strong>
      </p>
      <h2>13. Garantie de l’Utilisateur</h2>
      <p>
        L’Utilisateur garantit Le Média contre toutes plaintes, réclamations,
        actions et/ou revendications quelconques que Le Média pourrait subir du
        fait de la violation, par l’Utilisateur de l’une quelconque de ses
        obligations ou garanties aux termes des Conditions Générales.
      </p>
      <p>
        Il s’engage à indemniser Le Média de tout préjudice qu’elle subirait et
        à lui payer tous les frais, charges et/ou condamnations qu’elle pourrait
        avoir à supporter de ce fait.
      </p>
      <h2>14. Comportements prohibés</h2>
      <p>
        <strong>
          14.1 Il est strictement interdit aux Utilisateurs de copier et/ou de
          détourner à leurs fins ou à celles de tiers le concept, les
          technologies ou tout autre élément du Site du Média.
        </strong>
      </p>
      <p>
        <strong>
          14.2 Sont également strictement interdits : (i) tous comportements de
          nature à interrompre, suspendre, ralentir ou empêcher la continuité
          des Services, (ii) toutes intrusions ou tentatives d’intrusions dans
          les systèmes du Média, (iii) tous détournements des ressources système
          du Site, (iv) toutes actions de nature à imposer une charge
          disproportionnée sur les infrastructures de ce dernier, (v) toutes
          atteintes aux mesures de sécurité et d’authentification, (vi) tous
          actes de nature à porter atteinte aux droits et intérêts financiers,
          commerciaux ou moraux du Média ou des usagers de son Site, et enfin
          plus généralement (vii) tout manquement aux Conditions Générales.
        </strong>
      </p>
      <h2>15. Sanctions des manquements</h2>
      <p>
        En cas de manquement à l’une quelconque des dispositions des Conditions
        Générales ou plus généralement, d’infraction aux lois et règlements en
        vigueur par un Utilisateur, Le Média se réserve le droit de prendre
        toute mesure appropriée et notamment de :
      </p>
      <ol>
        <li>
          Suspendre l’accès aux Services de l’Utilisateur, auteur du manquement
          ou de l’infraction, ou y ayant participé,
        </li>
        <li>supprimer tout Contenu mis en ligne sur le Site,</li>
        <li>
          publier sur le Site tout message d’information que Le Média jugera
          utile,
        </li>
        <li>avertir toute autorité concernée,</li>
        <li>engager toute action judiciaire.</li>
      </ol>
      <h2>16. Responsabilité et garantie du Média</h2>
      <p>
        <strong>
          16.1 Le Média s’engage à fournir les Services avec diligence et selon
          les règles de l’art, étant précisé qu’il pèse sur elle une obligation
          de moyens, à l’exclusion de toute obligation de résultat, ce que les
          Utilisateurs reconnaissent et acceptent expressément.
        </strong>
      </p>
      <p>
        En conséquence, Le Média ne peut être tenue pour responsable des
        Contenus, dont les auteurs sont des tiers, toute réclamation éventuelle
        devant être dirigée en premier lieu vers l’auteur des Contenus en
        question.
      </p>
      <p>
        Les Contenus préjudiciables à un tiers peuvent faire l’objet d’une
        notification au Média par email à l’adresse indiquée à l’article
        « Exploitant du Site et des Services ».
      </p>
      <p>
        Le Média intervient en qualité de courtier en ce qu’elle met à la
        disposition des Abonnés et Socios des outils et moyens techniques leur
        permettant d’entrer en relation aux fins de discussions à travers le
        Site. Sa responsabilité se limite à la fourniture de ces moyens, tels
        que décrits aux présentes et à la mise en relation des Abonnés et Socio.
      </p>
      <p>
        <strong>
          16.2 Le Média décline toute responsabilité en cas de perte éventuelle
          des informations accessibles dans l’Espace Personnel de l’Abonné ou du
          Socio, celui-ci devant en sauvegarder une copie et ne pouvant
          prétendre à aucun dédommagement à ce titre.
        </strong>
      </p>
      <p>
        <strong>
          16.3 Le Média s’engage à procéder régulièrement à des contrôles afin
          de vérifier le fonctionnement et l’accessibilité du Site. A ce titre,
          Le Média se réserve la faculté d’interrompre momentanément l’accès au
          Site pour des raisons de maintenance. De même, Le Média ne saurait
          être tenue responsable des difficultés ou impossibilités momentanées
          d’accès au Site qui auraient pour origine des circonstances qui lui
          sont extérieures, la force majeure, ou encore qui seraient dues à des
          perturbations des réseaux de télécommunication.
        </strong>
      </p>
      <p>
        <strong>
          16.4 Le Média ne garantit pas aux Utilisateurs (i) que les Services,
          soumis à une recherche constante pour en améliorer notamment la
          performance et le progrès, seront totalement exempts d’erreurs, de
          vices ou défauts, (ii) que les Services, étant standards et nullement
          proposés à la seule intention d’un Utilisateur donné en fonction de
          ses propres contraintes personnelles, répondront spécifiquement à ses
          besoins et attentes.
        </strong>
      </p>
      <p>
        <strong>
          16.5 En tout état de cause, la responsabilité susceptible d’être
          encourue par Le Média au titre des présentes est expressément limitée
          aux seuls dommages directs avérés subis par l’Utilisateur.
        </strong>
      </p>
      <h2>17. Propriété intellectuelle du Média</h2>
      <p>
        Les systèmes, logiciels, structures, infrastructures, bases de données
        et contenus de toute nature (textes, images, visuels, musiques, logos,
        marques, base de données, etc …) exploités par Le Média au sein du Site
        sont protégés par tous droits de propriété intellectuelle ou droits des
        producteurs de bases de données en vigueur. Tous désassemblages,
        décompilations, décryptages, extractions, réutilisations, copies et plus
        généralement, tous actes de reproduction, représentation, diffusion et
        utilisation de l’un quelconque de ces éléments, en tout ou partie, sans
        l’autorisation du Média sont strictement interdits et pourront faire
        l’objet de poursuites judiciaires.
      </p>
      <h2>18. Politique de protection des données personnelles</h2>
      <h3>18.1 Données collectées</h3>
      <p>
        Dans le cadre de l’utilisation des Services, Le Média collecte des
        données à caractère personnel des Utilisateurs et notamment des Abonnés
        et Socio.
      </p>
      <p>
        Il s'agit des données à caractère personnel visées aux articles
        « Souscription d’un Abonnement auprès du Média » et « Devenir Socio »
        ci-avant.
      </p>
      <p>
        En application du principe de minimisation des données ou « Privacy by
        default », Le Média veille à collecter uniquement les données
        strictement nécessaires au regard de la finalité pour laquelle elles
        sont traitées.
      </p>
      <h2>18.2 Finalités de la collecte</h2>
      <p>Les données à caractère personnel sont traitées par Le Média pour :</p>
      <ul>
        <li>
          assurer la gestion et le suivi de la relation contractuelle entre elle
          et les Utilisateurs / les Abonnés / les Socios pour l’accès aux
          Services ;
        </li>
        <li>gérer la prospection ;</li>
        <li>respecter ses obligations légales et réglementaires ;</li>
        <li>et/ou gérer toute demande formulée sur le Site.</li>
      </ul>
      <h2>18.3 Destinataires des données</h2>
      <p>
        Le Média ne communique les données à caractère personnel qu’à ses
        services internes habilités, ses éventuels sous-traitants, ainsi qu’aux
        organismes publics, exclusivement pour répondre à ses obligations
        légales.
      </p>
      <p>
        Les données à caractère personnel ne font l’objet d’aucune cession,
        location, échange ou transfert au bénéfice d’un pays tiers ou d’une
        organisation internationale.
      </p>
      <h2>18.4 Durée de conservation des données</h2>
      <p>
        <strong>Données personnelles relatives aux Utilisateurs</strong>
      </p>
      <p>
        Les données à caractère personnel sont conservées pendant toute la durée
        de l’application des Conditions Générales et pendant une durée de un (1)
        an au-delà. Elles sont par la suite archivées pendant une durée de dix
        (10) ans, à des fins probatoires.
      </p>
      <p>
        <strong>Données personnelles relatives aux prospects</strong>
      </p>
      <p>
        Les données à caractère personnel relatives aux prospects sont
        conservées pendant une durée de trois (3) ans à compter de leur
        collecte. Cette durée est renouvelée à chaque manifestation positive du
        prospect à la suite d’une mesure de sollicitation personnalisée.
      </p>
      <h2>18.5 Sécurité des données</h2>
      <p>
        Le Média assure la sécurité des données à caractère personnel en mettant
        en place des mesures organisationnelles et techniques renforcées de
        sécurité.
      </p>
      <h2>18.6 Droits des Utilisateurs</h2>
      <p>
        L’Utilisateur est informé et accepte qu’il dispose d’un droit d’accès,
        de rectification, d’opposition, de limitation (c’est-à-dire que les
        données soient temporairement rendues inaccessibles), d’effacement de
        leurs données personnelles, ainsi qu’un droit à leur portabilité.
      </p>
      <p>
        Pour exercer ces droits, l’Utilisateur est tenu d’adresser un email au
        Média à l’adresse email suivante&nbsp;:{" "}
        <a href="mailto:cil@lemediatv.fr">cil@lemediatv.fr</a>. Chaque demande
        doit être accompagnée d’un justificatif d’identité. L’Utilisateur
        reconnaît et accepte qu’en cas de doute raisonnable quant à son
        identité, il pourra lui être demandé des informations supplémentaires
        nécessaires pour confirmer son identité.
      </p>
      <p>
        En cas de demandes manifestement infondées, excessives ou répétées, Le
        Média se réserve le droit de refuser d’y donner suite.
      </p>
      <h2>18.7 Fondements de la collecte</h2>
      <p>
        Cette collecte est systématiquement fondée soit sur le consentement de
        la personne concernée, soit sur l’exécution d’un contrat ou de mesures
        précontractuelles, soit sur le respect d’une obligation légale.
      </p>
      <h2>19. Publicité</h2>
      <p>
        Le Média se réserve la faculté d’insérer sur toute page du Site et dans
        toute communication aux Utilisateurs tous messages publicitaires ou
        promotionnels sous une forme et dans des conditions dont Le Média sera
        seule juge.
      </p>
      <h2>20. Liens et sites tiers</h2>
      <p>
        Le Média ne pourra en aucun cas être tenue pour responsable de la
        disponibilité technique de sites internet ou d’applications mobiles
        exploités par des tiers (y compris ses éventuels partenaires) auxquels
        l’Utilisateur accéderait par l'intermédiaire du Site.
      </p>
      <p>
        Le Média n'endosse aucune responsabilité au titre des contenus,
        publicités, produits et/ou services disponibles sur de tels sites et
        applications mobiles tiers dont il est rappelé qu’ils sont régis par
        leurs propres conditions d’utilisation.
      </p>
      <p>
        Le Média n'est pas non plus responsable des transactions intervenues
        entre l’Utilisateur et un quelconque annonceur, professionnel ou
        commerçant (y compris ses éventuels partenaires) vers lequel
        l’Utilisateur serait orienté par l'intermédiaire du Site et ne saurait
        en aucun cas être partie à quelques litiges éventuels que ce soit avec
        ces tiers concernant notamment la livraison de produits et/ou services,
        les garanties, déclarations et autres obligations quelconques auxquelles
        ces tiers sont tenus.
      </p>
      <h2>21. Gestion des cookies</h2>
      <h3>21.1 Définition des cookies</h3>
      <p>
        Les cookies sont des fichiers textes, souvent cryptés, stockés dans le
        navigateur de l’Utilisateur. Ils sont créés lorsque le navigateur charge
        un site internet donné&nbsp;: le site envoie des informations au
        navigateur, qui créé alors un fichier texte.
      </p>
      <p>
        Chaque fois que l’Utilisateur revient sur le même site, le navigateur
        récupère ce fichier et l’envoie au serveur du site internet.
      </p>
      <p>
        On peut distinguer deux types de cookies, qui n’ont pas les mêmes
        finalités&nbsp;: les cookies techniques et les cookies
        publicitaires&nbsp;:
      </p>
      <ul>
        <li>
          Les cookies techniques sont utilisés tout au long de la navigation de
          l’Utilisateur sur le site, afin de la faciliter et d’exécuter
          certaines fonctions. Un cookie technique peut par exemple être utilisé
          pour mémoriser les réponses renseignées dans un formulaire ou encore
          les préférences de l’Utilisateur s’agissant de la langue ou de la
          présentation d’un site internet, lorsque de telles options sont
          disponibles.
        </li>
        <li>
          Les cookies publicitaires peuvent être créés non seulement par le site
          internet sur lequel l’Utilisateur navigue, mais également par d’autres
          sites internet diffusant des publicités, annonces, widgets ou autres
          éléments sur la page affichée. Ces cookies peuvent notamment être
          utilisés pour effectuer de la publicité ciblée, c’est-à-dire de la
          publicité déterminée en fonction de votre navigation.
        </li>
      </ul>
      <p>
        Nous utilisons des cookies techniques et publicitaires. Ceux-ci sont
        stockés dans le navigateur de l’Utilisateur pour une période de treize
        (13) mois.
      </p>
      <p>
        Le Média utilise par ailleurs Google Analytics qui est un outil
        statistique d’analyse d’audience qui génère un cookie permettant de
        mesurer le nombre de visites sur le site, le nombre de pages vues et
        l’activité des visiteurs. L’adresse IP de l’Utilisateur est également
        collectée pour déterminer la ville depuis laquelle il se connecte. La
        durée de conservation de ce cookie est également de treize (13) mois.
      </p>
      <h3>21.2 Finalités de la dépose des cookies</h3>
      <p>
        <strong>
          Maintien de la continuité des services proposés sur le Site
        </strong>
      </p>
      <p>
        Les cookies exploités à cet effet permettent de faire en sorte que les
        choix que l’Utilisateur a exprimé sur le Site soient gardés en mémoire
        de sorte que l’Utilisateur n’ait pas à ré-exprimer ces choix à chaque
        nouvelle navigation sur le Site.
      </p>
      <p>
        Les désactiver aura pour conséquence à ce que Le Média propose à
        l’Utilisateur des actions ou choix à chaque navigation sur le Site,
        quand bien même l’Utilisateur aurait exprimé ces choix lors de
        précédentes navigations sur le Site.
      </p>
      <p>
        <strong>Publicités personnalisés</strong>
      </p>
      <p>
        Ces cookies permettent d’analyser votre navigation et de définir vos
        centres d’intérêts pour vous proposer des publicités plus pertinentes.
      </p>
      <p>
        Les désactiver n’a aucun impact sur le volume de publicités que vous
        recevrez, mais celles-ci ne seront pas personnalisées.
      </p>
      <p>
        <strong>Contenus personnalisés</strong>
      </p>
      <p>
        Ces cookies permettent d’analyser votre navigation et de définir vos
        centres d’intérêts pour personnaliser nos services et contenus.
      </p>
      <p>
        Les désactiver nous empêche de vous proposer une expérience
        personnalisée au moyen de cookies.
      </p>
      <p>
        <strong>Mesure d’audience</strong>
      </p>
      <p>
        Ces cookies permettent d’établir des statistiques de fréquentation de
        notre site.
      </p>
      <p>
        Les désactiver nous empêche de suivre et d’améliorer la qualité de la
        navigation sur notre Site au moyen de cookies.
      </p>
      <h2>22. Durée des Conditions Générales</h2>
      <h3>22.1 Pour les Utilisateurs autres que les Abonnés ou Socio</h3>
      <p>
        Sauf disposition expresse contraire, les Conditions Générales
        s’appliquent à l’Utilisateur non Abonné ou Socio pendant toute la durée
        de son accès au Site et de son utilisation des Services.
      </p>
      <h3>22.2 Pour les Abonnés</h3>
      <p>
        L’Abonnement pour une durée de un (1) an à compter de sa souscription
        (ci-après la « <strong>Période Initiale</strong> »).
      </p>
      <p>
        Elle se renouvelle tacitement aux mêmes termes et conditions pour des
        périodes successives de même durée (ci-après la ou les « 
        <strong>Périodes Renouvelées</strong> »), sauf désabonnement de l’Abonné
        en cliquant sur le bouton « Me désabonner » depuis son Compte.
      </p>
      <p>
        L’Abonné qui se désabonne dans ces conditions est informé que son
        Abonnement prendra fin à l’issue de la Période suivant sa demande de
        désabonnement.
      </p>
      <h3>22.3 Pour les Socio</h3>
      <p>
        les Socios peuvent faire le choix de se désengager totalement des
        Services du Média ou de ne plus être Socio tout en restant Abonné.
      </p>
      <p>
        Aux fins de se désengager du seul statut de Socio ou du statut de Socio
        et d’Abonné, le Socio doit adresser au Média une lettre recommandée avec
        accusé de réception à l’adresse mentionnée à l’article « Exploitant du
        Site et des Services » mentionnant sa volonté : soit de ne plus devenir
        Socio tout en restant Abonné, soit de se désengager totalement des
        Services du Média.
      </p>
      <p>
        Son désengagement sera effectif à l’issue de la Période suivant l’envoi
        de son courrier recommandé.
      </p>
      <h2>Modifications</h2>
      <p>
        Le Média se réserve la faculté de modifier à tout moment les Conditions
        Générales.
      </p>
      <p>
        L’Utilisateur sera informé de ces modifications par tout moyen utile.
      </p>
      <p>
        Les conditions générales modifiées s’appliquent immédiatement aux
        Utilisateurs non-abonnés qui utilisent les Services après leur entrée en
        vigueur. Les Utilisateurs non-abonnés sont donc invités à consulter sur
        le Site la dernière version en vigueur des conditions générales.
      </p>
      <p>
        S’il est Abonné ou Socio, les conditions générales modifiées
        s’appliqueront à l’égard de l’Abonné ou du Socio à compter du
        renouvellement de la Période d’Abonnement suivant leur entrée en
        vigueur.
      </p>
      <p>
        L’Utilisateur, autre que l’Abonné ou le Socio, qui n’accepte pas les
        conditions générales modifiées ne doit pas accéder au Site, ni utiliser
        les Services.
      </p>
      <p>
        L’Abonné ou le Socio qui n’accepte pas les conditions générales
        modifiées doit dénoncer son Abonnement dans les conditions de l’article
        « Durée des Conditions Générales ».
      </p>
      <p>
        Tout Utilisateur qui a recours aux Services postérieurement à l’entrée
        en vigueur des conditions générales modifiées est réputé avoir accepté
        ces modifications.
      </p>
      <h2>24. Médiation</h2>
      <p>
        En cas de litige relatif aux présentes Conditions d’utilisation,
        l’Utilisateur a la faculté de recourir gratuitement à un médiateur de la
        consommation conformément aux articles L612-1 du Code de la
        consommation.
      </p>
      <p>
        Une liste des médiateurs agrées est disponible sur le site internet de
        la médiation de la consommation accessible à l’adresse suivante&nbsp;:
        http://www.economie.gouv.fr/mediation-conso.{" "}
      </p>
      <p>
        L’Utilisateur a en outre la possibilité de déposer une plainte via la
        plateforme de règlement en ligne des litige (dites plateforme
        «&nbsp;RLL&nbsp;») accessible au moyen du lien ci-dessous&nbsp;:
        https://webgate.ec.europa.eu/odr/main/?event=main.home.show&lng=FR
      </p>
      <h2>25. Loi applicable et juridiction</h2>
      <p>Les Conditions Générales sont régies par la loi française.</p>
      <p>
        En cas de contestation sur la validité, l’interprétation et/ou
        l’exécution des Conditions Générales, les Parties conviennent que les
        tribunaux de Paris seront exclusivement compétents pour en juger, sauf
        règles de procédure impératives contraires.
      </p>
      <h2>26. Entrée en vigueur</h2>
      <p>Les Conditions Générales sont entrées en vigueur le 16 juin 2021.</p>
    </section>
  );
}

export default AnnexesCGU;
